import type { ApiError } from 'utils/http/apiErrorHelper';

import type { PriceImprovementExpirationTime } from './priceImprovementRequest.model';

export type PriceImprovementRequestActions =
  | PriceImprovementExpanded
  | PriceImprovementCreateRequested
  | PriceImprovementCreateReceived
  | PriceImprovementCancelRequested
  | PriceImprovementCancelReceived
  | PriceImprovementCancelFailed
  | PriceImprovementDiscarded
  | PriceImprovementCommentChanged
  | PriceImprovementRequestedTradingOfferChanged
  | PriceImprovementExpirationTimeChanged
  | PriceImprovementCreateFailed
  | PriceImprovementErrorDismissed
  | PriceImprovementInitialized
  | PriceImprovementTraderAcknowledged
  | PriceImprovementTraderRejected
  | PriceImprovementTraderValidated;

export function priceImprovementCreateRequested(quoteId: string) {
  return {
    type: 'PRICE_IMPROVEMENT_CREATE_REQUESTED' as const,
    quoteId,
  };
}
export type PriceImprovementCreateRequested = ReturnType<typeof priceImprovementCreateRequested>;

export function priceImprovementCreateReceived(quoteId: string, requestForPriceImprovementId: string) {
  return {
    type: 'PRICE_IMPROVEMENT_CREATE_RECEIVED' as const,
    quoteId,
    requestForPriceImprovementId,
  };
}
export type PriceImprovementCreateReceived = ReturnType<typeof priceImprovementCreateReceived>;

export function priceImprovementCreateFailed(quoteId: string, error: ApiError) {
  return {
    type: 'PRICE_IMPROVEMENT_CREATE_FAILED' as const,
    quoteId,
    error,
  };
}
export type PriceImprovementCreateFailed = ReturnType<typeof priceImprovementCreateFailed>;

export function priceImprovementCancelRequested(quoteId: string) {
  return {
    type: 'PRICE_IMPROVEMENT_CANCEL_REQUESTED' as const,
    quoteId,
  };
}
export type PriceImprovementCancelRequested = ReturnType<typeof priceImprovementCancelRequested>;

export function priceImprovementCancelReceived(quoteId: string) {
  return {
    type: 'PRICE_IMPROVEMENT_CANCEL_RECEIVED' as const,
    quoteId,
  };
}
export type PriceImprovementCancelReceived = ReturnType<typeof priceImprovementCancelReceived>;

export function priceImprovementCancelFailed(quoteId: string, error: ApiError) {
  return {
    type: 'PRICE_IMPROVEMENT_CANCEL_FAILED' as const,
    quoteId,
    error,
  };
}
export type PriceImprovementCancelFailed = ReturnType<typeof priceImprovementCancelFailed>;

export function priceImprovementDiscarded(quoteId: string) {
  return {
    type: 'PRICE_IMPROVEMENT_DISCARDED' as const,
    quoteId,
  };
}
export type PriceImprovementDiscarded = ReturnType<typeof priceImprovementDiscarded>;

export function priceImprovementCommentChanged(quoteId: string, comment?: string) {
  return {
    type: 'PRICE_IMPROVEMENT_COMMENT_CHANGED' as const,
    quoteId,
    comment,
  };
}
export type PriceImprovementCommentChanged = ReturnType<typeof priceImprovementCommentChanged>;

export function priceImprovementRequestedTradingOfferChanged(quoteId: string, requestedTradingOffer?: number) {
  return {
    type: 'PRICE_IMPROVEMENT_REQUESTED_TRADING_OFFER_CHANGED' as const,
    quoteId,
    requestedTradingOffer,
  };
}
export type PriceImprovementRequestedTradingOfferChanged = ReturnType<
  typeof priceImprovementRequestedTradingOfferChanged
>;

export function priceImprovementExpirationTimeChanged(
  quoteId: string,
  expirationTime: Nullable<PriceImprovementExpirationTime>,
) {
  return {
    type: 'PRICE_IMPROVEMENT_EXPIRATION_TIME_CHANGED' as const,
    quoteId,
    expirationTime,
  };
}
export type PriceImprovementExpirationTimeChanged = ReturnType<typeof priceImprovementExpirationTimeChanged>;

export function priceImprovementExpanded(quoteId: string, isExpanded: boolean) {
  return {
    type: 'PRICE_IMPROVEMENT_EXPANDED' as const,
    quoteId,
    isExpanded,
  };
}
export type PriceImprovementExpanded = ReturnType<typeof priceImprovementExpanded>;

export function priceImprovementErrorDismissed(quoteId: string) {
  return {
    type: 'PRICE_IMPROVEMENT_ERROR_DISMISSED' as const,
    quoteId,
  };
}
export type PriceImprovementErrorDismissed = ReturnType<typeof priceImprovementErrorDismissed>;

export function priceImprovementInitialized(quoteId: string) {
  return {
    type: 'PRICE_IMPROVEMENT_INITIALIZED' as const,
    quoteId,
  };
}
export type PriceImprovementInitialized = ReturnType<typeof priceImprovementInitialized>;

export function priceImprovementTraderAcknowledged(requestForPriceImprovementId: string, quoteId: string) {
  return {
    type: 'PRICE_IMPROVEMENT_TRADER_ACKNOWLEDGED' as const,
    quoteId,
    requestForPriceImprovementId,
  };
}
export type PriceImprovementTraderAcknowledged = ReturnType<typeof priceImprovementTraderAcknowledged>;

export function priceImprovementTraderRejected(requestForPriceImprovementId: string, quoteId: string, comment: string) {
  return {
    type: 'PRICE_IMPROVEMENT_TRADER_REJECTED' as const,
    quoteId,
    requestForPriceImprovementId,
    comment,
  };
}
export type PriceImprovementTraderRejected = ReturnType<typeof priceImprovementTraderRejected>;

export function priceImprovementTraderValidated(
  requestForPriceImprovementId: string,
  quoteId: string,
  priceAdjustment: number,
  comment: string,
) {
  return {
    type: 'PRICE_IMPROVEMENT_TRADER_VALIDATED' as const,
    quoteId,
    requestForPriceImprovementId,
    priceAdjustment,
    comment,
  };
}
export type PriceImprovementTraderValidated = ReturnType<typeof priceImprovementTraderValidated>;
